import { CategoryService } from "@/services/nextshop/category.service";

export default {
  methods: {
    async getListCategory() {
      try {
        const params = {
          queryString: { parentId: { eq: "" } },
          sort: "-id",
          lastItem: "",
          limit: 100,
        };
        const response = await CategoryService.getList(params);
        if (response.success) {
          return response.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
  }
}